import styled, { keyframes } from 'styled-components';

import { ImageBackgroundLogoIbFullscreen } from '~/assets/images';

const appearOpacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const Container = styled.div`
  background: url(${ImageBackgroundLogoIbFullscreen}) 0% / cover fixed,
    ${(props) => props.theme.colors.background};

  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: relative;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 45.3rem;

  padding: 2rem;

  animation: ${appearOpacity} 180ms ease-in;

  @media (min-width: 768px) {
    padding: 0;
  }

  /* Logo */
  > svg {
    margin: 5.4rem 0 3rem;
  }

  > form {
    width: 100%;
    margin: 2.8rem 0 2.2rem;

    > div {
      & + div {
        margin-top: 2.2rem;
      }
    }
  }
`;

export const Title = styled.h1`
  font-weight: ${({ theme }) => theme.fontWeight.LatoBold};
  font-size: 3rem;
  color: ${({ theme }) => theme.colors.yellow};

  text-align: center;

  @media (min-width: 425px) {
    font-size: 3.8rem;
  }
`;

export const Description = styled.ul`
  width: 100%;

  > li {
    padding: 2rem 0 2.7rem;
    border-bottom: 1px solid #e2e2e2;

    font-size: 1.6rem;
    color: ${({ theme }) => theme.colors.white};

    text-align: center;

    @media (min-width: 425px) {
      font-size: 2rem;
    }
  }
`;

export const Price = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;

  height: 111px;

  background: #dbdbdb;
  border-radius: 0.4rem;

  margin: 5rem 0;

  > h1 {
    font-size: 3.6rem;
    color: ${({ theme }) => theme.colors.black};

    letter-spacing: -0.57px;

    @media (min-width: 425px) {
      font-size: 5.2rem;
    }
  }
`;
